import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { dateOnlyBodyTemplate } from '../../../../utils/dateUtils';

const stripLeadingZeros = (value) => {
    if (value === null || value === undefined) return '';
    return String(value).replace(/^0+/, '') || '0';
};

const MaterialCatalogMovementTable = ({ items, lazyParams, totalRecords, loading, onPage, th, isDealer }) => {
    return (
        <DataTable
            value={items}
            lazy
            paginator
            first={lazyParams.first}
            rows={lazyParams.rows}
            onPage={onPage}
            totalRecords={totalRecords}
            loading={loading}
            emptyMessage={th('common.noData')}
            rowsPerPageOptions={[5, 10, 25, 50]}
            showGridlines
            stripedRows
            tableStyle={{ minWidth: '60rem' }}
        >
            {!isDealer && (
                <Column
                    field="dealerCode"
                    header={th('materialCatalog.dealerCode')}
                    body={(rowData) => rowData.dealerCode ?? '-'}
                    style={{ minWidth: '120px' }}
                />
            )}
            <Column
                field="movementDate"
                header={th('materialCatalog.movementDate')}
                body={(rowData) => dateOnlyBodyTemplate(rowData, 'movementDate') ?? '-'}
                style={{ minWidth: '150px' }}
            />
            <Column field="transactionType" header={th('materialCatalog.transactionType')} body={(rowData) => rowData.transactionType ?? '-'} style={{ minWidth: '250px' }} />
            <Column field="quantity" header={th('materialCatalog.quantity')} body={(rowData) => rowData.quantity ?? '-'} style={{ minWidth: '100px' }} />
            <Column field="customerSupplier" header={th('materialCatalog.customerSupplier')} body={(rowData) => rowData.customerSupplier ?? '-'} style={{ minWidth: '200px' }} />
            <Column field="recordedBy" header={th('materialCatalog.recordedBy')} body={(rowData) => rowData.recordedBy ?? '-'} style={{ minWidth: '150px' }} />
            <Column field="partCode" header={th('materialCatalog.partCode')} body={(rowData) => rowData.partCode ?? '-'} style={{ minWidth: '150px' }} />
        </DataTable>
    );
};

export default MaterialCatalogMovementTable;
